import type { EditableToolValidationComponentProps } from "@app/components/assistant/conversation/editable_tool_validation/types";
import { GmailDraftReviewCard } from "@app/components/home/GmailDraftReviewCard";

export function GmailSendMailValidation({
  blockedAction,
  alwaysAllowLabel,
  isSubmitting,
  isPulsing,
  onApproveWithEditedArguments,
}: EditableToolValidationComponentProps) {
  return (
    <GmailDraftReviewCard
      blockedAction={blockedAction}
      alwaysAllowLabel={alwaysAllowLabel ?? undefined}
      isValidating={isSubmitting}
      isPulsing={isPulsing}
      onApprove={async ({ neverAskAgain, editedArguments }) => {
        await onApproveWithEditedArguments({
          editedArguments,
          approved: neverAskAgain ? "always_approved" : "approved",
        });
        return true;
      }}
      onReject={async () => {
        await onApproveWithEditedArguments({
          editedArguments: {},
          approved: "rejected",
        });
        return true;
      }}
    />
  );
}
